import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isAuthenticated } from '../../store/selectors/AuthSelectors';
import { restoreAuthState } from '../../services/AuthService';
import HomeLanding from '../pages/HomeLanding';
import PublicNavbar from '../layouts/PublicNavbar';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

const RootRoute = () => {
  const isAuth = useSelector(isAuthenticated);
  const dispatch = useDispatch();
  const [isRestoring, setIsRestoring] = useState(false);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
  
  // Check for tokens in storage as fallback
  const hasToken = () => {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    let accessToken = null;

    if (rememberMe) {
      accessToken = localStorage.getItem('accessToken');
    } else {
      accessToken = sessionStorage.getItem('accessToken');
      if (!accessToken) {
        accessToken = localStorage.getItem('tempAccessToken');
      }
    }
    
    return !!accessToken;
  };

  // Try to restore auth state if we have tokens but aren't authenticated
  useEffect(() => {
    const checkAndRestoreAuth = async () => {
      if (!isAuth && hasToken() && !isRestoring) {
        console.log('RootRoute: Attempting to restore auth state');
        setIsRestoring(true);
        
        try {
          const restored = await restoreAuthState(dispatch);
          console.log('RootRoute: Auth restoration result:', restored);
        } catch (error) {
          console.error('RootRoute: Auth restoration failed:', error);
        } finally {
          setIsRestoring(false);
          setHasCheckedAuth(true);
        }
      } else {
        setHasCheckedAuth(true);
      }
    };

    checkAndRestoreAuth();
  }, [dispatch, isAuth, isRestoring]);

  // Show loading while restoring authentication
  if (isRestoring) {
    return <LoadingSpinner label="Loading…" />;
  }

  // Always show landing page, regardless of authentication status
  // The session will be maintained in the background
  return (
    <>
      <PublicNavbar />
      <div className="home-page-offset"><HomeLanding /></div>
    </>
  );
};

export default RootRoute;
